module.exports = __webpack_public_path__ + "static/media/Kuzma.8b69d5d4.png";